import React, { useEffect, useContext } from "react";
import Router from "./Router";

import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";
import { useQuery } from '@tanstack/react-query'
import axios from "axios";

const GetCards:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {setCardData} = rootStore.cardsStore;
  const {setSubjects} = rootStore.subjectStore;
  const {setYears} = rootStore.yearsStore;
  const {ccSetCards, ccSetForms, ccSetSubjectAreas, ccSetSchoolTerms, ccSetImages} = rootStore.coCurricularStore;


  const loadCardData = async () => {
    const response = await axios.post("/wallapi/graphql",
    {
      query: `
      query GetCardData {
        subjects(first: 1000, where: {orderby: TERM_ORDER}) {
          nodes {
            name
            slug
            termTaxonomyId
            subjectImage {
              overlayOpacity
              image {
                node {
                  mediaItemUrl
                }
              }
            }
            subjectType {
              subjectType
            }
          }
        },
        
        forms(first: 1000, where: {orderby: TERM_ORDER}) {
          nodes {
            name
            slug
            termTaxonomyId
            yearFormInformation {
              content
            }
          }
        },
        
        cards(first: 1000) {
          nodes {
            title
            content
            slug
            databaseId
            terms {
              nodes {
                name
                termTaxonomyId
                taxonomyName
              }
            }
            cardDetails {
              content
              waysOfThinkingAndLearning
              toolsForWorking
              thePupil
              level
            }
          }
        },
      }
      `
    });
    return response.data.data;
  }


  const loadCoCurricularData = async () => {
    const response = await axios.post("/wallapi/graphql",
    {
      query: `
      query GetCoCurricularData {
        coCurricularCards(first: 1000) {
          nodes {
            content
            title
            slug
            coCurricular {
              form {
                nodes {
                  name
                  slug
                  termTaxonomyId
                }
              }
              coCurricularSubjectArea {
                nodes {
                  name
                  slug
                }
              }
              image {
                node {
                  mediaItemUrl
                }
              }
              days {
                nodes {
                  name
                  termTaxonomyId
                  slug
                }
              }
              time
              venue
              term {
                nodes {
                  name
                  slug
                  termTaxonomyId
                }
              }
            }
          }
        },

        coCurricularSubjectAreas(first: 1000, where: {orderby: TERM_ORDER}) {
          nodes {
            name
            slug
            termTaxonomyId
          }
        },

        schoolTerms {
          nodes {
            name
            slug
            termTaxonomyId
          }
        },

      }
      `
    });
    return response.data.data;
  }

  const loadImageData = async () => {
    const response = await axios.post("/wallapi/graphql",
    {
      query: `
      query GetCoCurricularData {
        coCurricularImages {
          coCurricularImageField {
            coCurricularImages(first: 100) {
              nodes {
                mediaItemUrl
              }
            }
          }
        }
      }`
    });
    return response.data.data;
  }


  const { isPending, isError, data, isSuccess } = useQuery({
    queryKey: ['cardData'],
    queryFn: async () => 
      await loadCardData(),
  });

  const { isPending: isPending2, isError: isError2, data: data2, isSuccess: isSuccess2 } = useQuery({
    queryKey: ['CocurricularData'],
    queryFn: async () => 
      await loadCoCurricularData(),
  });

  const { isPending: isPending3, isError: isError3, data: data3, isSuccess: isSuccess3 } = useQuery({
    queryKey: ['CocurricularImageData'],
    queryFn: async () => 
      await loadImageData(),
  });

  useEffect(() => {
    if(data && data2 && data3) {
      setCardData(data.cards.nodes);
      ccSetForms(data.forms.nodes);
      setSubjects(data.subjects.nodes);
      setYears(data.forms.nodes);
      ccSetCards(data2.coCurricularCards.nodes);
      ccSetSubjectAreas(data2.coCurricularSubjectAreas.nodes);
      ccSetSchoolTerms(data2.schoolTerms.nodes);
      ccSetImages(data3.coCurricularImages.coCurricularImageField.coCurricularImages.nodes)
    }
  }, [data, data2, data3]);


  if(isPending || isPending2 || isPending3) return (
    <div className='loader'>
      <i className="fa-duotone fa-spinner-third"></i>
      <p>Loading...</p>
    </div>);
  if(isError) return <p>Error loading</p>

  return (
    <Router />
  )
});

export default GetCards;
